// extracted by mini-css-extract-plugin
export default {"logo":"assettype_logo__nSIcn","text":"assettype_text__h6KHF","delete":"assettype_delete__6I4tM","main":"assettype_main__iqW4O"};